export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -02.458cefc8.png";